import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Image from 'next/image';

import MeshBackground from 'react-scale/components/ui/webgl';
import CTA from 'react-scale/components/ui/cta';

import PropTypes from 'prop-types';

const HeroDefaultWithImage = ({
  icon,
  overtitle,
  title,
  product,
  subtitle,
  cta,
  bgAnimated,
  image
}) => (
  <div className="text-white bg-black">
    {bgAnimated && <MeshBackground />}
    <div className="relative">
      <div className="container flex flex-col items-center w-full py-10 lg:flex-row lg:gap-10 lg:py-32">
        <div className={cn('w-full', product ? 'lg:w-5/12' : 'lg:w-6/12')}>
          {icon && (
            <div className="relative w-16 h-16 mb-4">
              <Image src={icon.src} alt={icon.alt} width={icon.width} height={icon.height} />
            </div>
          )}
          <h4 className="inline-block mb-4 text-overtitle-sm text-gradient">{overtitle}</h4>
          <h1
            className={cn('font-aeonik', product ? 'text-5xl md:text-7xl' : 'text-4xl md:text-5xl')}
          >
            {title} <span className="text-gradient">{product}</span>
          </h1>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className={cn('mt-6 text-base lg:text-lg', product ? 'lg:w-3/4' : 'w-full')}
          >
            {subtitle}
          </ReactMarkdown>
          <div className="mt-12 mb-12 lg:w-3/4 lg:mb-0">
            <CTA cta={cta} />
          </div>
        </div>
        <div className={cn('flex-shrink w-full relative', product ? 'lg:w-7/12' : 'lg:w-6/12')}>
          <Image
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.width}
            priority
            quality={100}
          />
        </div>
      </div>
    </div>
  </div>
);

HeroDefaultWithImage.propTypes = {
  bgAnimated: PropTypes.bool,
  image: PropTypes.objectOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    })
  )
};

HeroDefaultWithImage.defaultProps = {
  bgAnimated: true,
  image: {
    src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9245b80daf6e46258858cabd5994367f',
    alt: undefined,
    width: 1630,
    height: 1336
  }
};

export default HeroDefaultWithImage;
